import React from 'react';

const {
  tagsJson,
} = require('./tags/mingoapp/tags');

// eslint-disable-next-line max-len
const MINGOAPP_LOGO = '/themes/theme/mingoApp/mingoApp-logo.png';
const MINGOAPP_DARK_LOGO = '/themes/theme/mingoApp/mingoApp-dark-logo.png';

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};


const MingoAppTheme = {
  organisationId: '9aae0ea7-27e1-447e-a17d-b180a3742a4e',
  headerLogo: {
    src: MINGOAPP_LOGO,
    alt: 'Mingo App Logo',
    size: 70,
  },
  darkLogo: {
    src: MINGOAPP_DARK_LOGO,
    alt: 'Mingo App Logo',
    size: 70,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #03A8C2',
    height: 80,
  },
  title: 'Mingo App',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="80"
        src={MINGOAPP_DARK_LOGO} alt="Mingo App Logo"
      />
      <br /><br />
      <h3>Mingo App</h3>
    </div>
  ),
  shareSite: 'https://share.mingoapp.dk ',
  primaryButtonColorStyle: {
    background: '#03A8C2',
    color: 'white',
    margin: 5,
  },
  // secondaryButtonColorStyle: {
  //   background: '#a5a5a5',
  //   color: 'white',
  //   margin: 5,
  // },
  tagButtonColor: 'blue',
  formTitle: () => (
    <h3 style={textAlignCentre}>Opret profil</h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre50p}>Velkommen til Mingo App</p>
      <br />
      <p style={textAlignCentre50p}>Opret din profil, så du kan deltage i lækre kampagner i Mingo App.</p>
      <br />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Vi ser frem til samarbejdet med dig, </p>
      <br />
      <p style={textAlignCentre}>
        1. Vær ærlig i dit content, når du fortæller om kampagnens produkter.
        <br />
        2. Vær kreativ i dit content, det giver virksomheder motivation til at bruge dig igen.
      </p>
      <br />
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Tak for din tilmelding!</p>
      <br />
    </div>
  ),
  // socialHandle1HtmlTop: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  // socialHandle1HtmlBottom: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  // socialHandle2HtmlTop: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  socialHandle2HtmlBottom: () => (
    <h3 style={textAlignCentre}>Det er ikke et krav at udfylde alle felter.</h3>
  ),
  // socialHandle3HtmlTop: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  socialHandle3HtmlBottom: () => (
    <h3 style={textAlignCentre}>Det er ikke et krav at udfylde alle felter.</h3>
  ),
  // personalDetailHtmlTop: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  // personalDetailHtmlBottom: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  tagsHtmlTop: () => (
    <h3 style={textAlignCentre}>Vælg dine interesser her (vælg mindst to)</h3>
  ),
  // tagsHtmlBottom: () => (
  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
  // ),
  tagsJson,
  tAndCUrl: 'https://dyzio.co/terms-of-use',
};

export default MingoAppTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/mingoapp.js
 **/